import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private api: ApiService) { }

  /**
   * Coalesces concurrent calls with the same client_id (e.g. Lead + Toolbar on first paint)
   * into a single HTTP request. Map entry is removed when all subscribers finish.
   */
  private findAllUsersInflight = new Map<string, Observable<any>>();

  findAllUsers(data: any): Observable<any> {
    const key = String(data?.client_id ?? '_');
    const existing = this.findAllUsersInflight.get(key);
    if (existing) {
      return existing;
    }
    const shared = this.api.post(environment.findAllUsers, data).pipe(
      finalize(() => this.findAllUsersInflight.delete(key)),
      shareReplay({ bufferSize: 1, refCount: true })
    );
    this.findAllUsersInflight.set(key, shared);
    return shared;
  }

  /** Clears coalescing map (e.g. after explicit logout if storage is not fully cleared). */
  clearFindAllUsersInflight(): void {
    this.findAllUsersInflight.clear();
  }
  getAllData(data:any): Observable<any> {
    return this.api.post(environment.getAllUsers,data);
  }

  getAllCenter(data:any): Observable<any> {
    return this.api.post(environment.getAllCenter,data);
  }
  getAllDepartment(data:any): Observable<any> {
    return this.api.post(environment.getAllDepartment,data);
  }
  getAllRoles(data:any): Observable<any> {
    return this.api.post(environment.getAllRoles,data);
  }
  createUser(data:any): Observable<any> {
    return this.api.post(environment.createUser,data);
  }
  updateUser(data:any): Observable<any> {
    return this.api.post(environment.updateUser,data);
  }

  /** Part-d: hard delete user after lead ownership checks (encrypted request/response). */
  permanentlyDeleteUser(data: { user_id: number; client_id: number }): Observable<any> {
    return this.api.post(environment.permanentlyDeleteUser, data);
  }

  /** Bulk-reassign all leads then hard-delete user asynchronously. Returns 202 immediately. */
  reassignAndDeleteUser(data: { user_id: number; client_id: number; reassign_to_user_id: number }): Observable<any> {
    return this.api.post(environment.reassignAndDeleteUser, data);
  }

  /** Poll the status of an async user deletion job. */
  getUserDeletionStatus(data: { user_id: number; client_id: number }): Observable<any> {
    return this.api.post(environment.getUserDeletionStatus, data);
  }
  getUser(data:any): Observable<any> {
    return this.api.post(environment.getUser,data);
  }
  userModuleDropdownListing(): Observable<any> {
    return this.api.get(environment.userModuleDropdownListing);
  }

  checkUsernameExists(data:any): Observable<any> {
    return this.api.post(environment.checkUsernameExists, data)
  }


  
}


